<template>
  <div class="sorter-options">
    <list-searchable-options
      :options="options"
      :placeholder="$t('listSorter.search')"
      @select="emit('add-sort', $event)"
    />
  </div>
</template>

<script setup>
import ListSearchableOptions from '@/components/list/ListSearchableOptions.vue';
import useSorterOptions from '@/composables/sort/sorter-options';
import { computed } from 'vue';

const props = defineProps({
  sortOptions: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['add-sort']);

const { optionIcon, optionLabel } = useSorterOptions();

const options = computed(() => props.sortOptions.map((o) => ({
  text: optionLabel(o),
  icon: optionIcon(o),
  value: o,
})));

</script>
